export function sanitizeEmailInput(value: string): string {
  return value.replace(/\s+/g, '');
}

export function trimInputValue(value: string): string {
  return value.trim();
}
